import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ShareModal from "./ShareModal.jsx";
import { reportPageLoadPerformance } from '../utils/usageEvents';

const fetch = require("node-fetch");

class SolvedJoke extends Component {
  constructor(props) {
    super(props);
    this.state = { status: 'loading', joke: null, share_modal_open: false };
  }

  componentDidMount() {
    // a no-op if Layout (or another route) already reported this real
    // page load - only matters when a player's very first load lands
    // directly here, e.g. a shared /solved/<id> link
    reportPageLoadPerformance(Number(this.props.match.params.id) || null);
    this.load();
  }

  async load() {
    try {
      const response = await fetch('/api/joke_detail/' + this.props.match.params.id);
      if (!response.ok) {
        this.setState({ status: 'not_found' });
        return;
      }
      const json = await response.json();
      this.setState({ status: 'loaded', joke: json.joke });
    } catch (error) {
      this.setState({ status: 'error' });
    }
  }

  // staff-only - joke_detail only ever sends `stats` when the request's
  // own session is staff, so a regular player never even gets this data
  render_admin_stats(stats) {
    const pct = (value) => (value == null ? 'N/A' : `${Math.round(value * 100)}%`);
    const secs = (value) => (value == null ? 'N/A' : `${value.toFixed(1)}s`);
    return (
      <div id="solved_joke_admin_stats">
        <div id="solved_joke_admin_stats_title">Site stats (staff only)</div>
        <div className="solved_joke_admin_stat"><span>Started</span><b>{stats.started}</b></div>
        <div className="solved_joke_admin_stat"><span>Completed</span><b>{stats.completed}</b></div>
        <div className="solved_joke_admin_stat"><span>Completion rate</span><b>{pct(stats.completion_rate)}</b></div>
        <div className="solved_joke_admin_stat"><span>Avg solve time</span><b>{secs(stats.avg_solve_seconds)}</b></div>
        <div className="solved_joke_admin_stat"><span>Used a hint</span><b>{pct(stats.hint_rate)}</b></div>
      </div>
    );
  }

  render() {
    if (this.state.status === 'loading') {
      return <div id="solved_joke_page"><p>Loading…</p></div>;
    }
    if (this.state.status !== 'loaded') {
      return (
        <div id="solved_joke_page">
          <Link to="/profile" id="solved_joke_back_link">← Back to your profile</Link>
          <p>That joke couldn't be found.</p>
        </div>
      );
    }
    const joke = this.state.joke;
    return (
      <div id="solved_joke_page">
        <Link to="/profile" id="solved_joke_back_link">← Back to your profile</Link>
        <h2 id="solved_joke_setup">{joke.setup}</h2>
        {joke.image && <img src={joke.image} alt="" id="solved_joke_image" />}
        <p id="solved_joke_punchline">{joke.punchline}</p>
        <div id="solved_joke_actions">
          <Link to={'/joke/' + joke.id} id="solved_joke_restart">Redo 🔁</Link>
          <button id="share_joke" onClick={() => this.setState({ share_modal_open: true })}>
            Share 📤
          </button>
        </div>
        {joke.stats && this.render_admin_stats(joke.stats)}
        {this.state.share_modal_open &&
          <ShareModal
            jokeId={joke.id}
            onClose={() => this.setState({ share_modal_open: false })}
          />
        }
      </div>
    );
  }
}

export default SolvedJoke;
